import Vue from 'vue';
import * as html from './gp-button.html';

export default Vue.component('gp-button', {
	render: html.render,
	staticRenderFns: html.staticRenderFns,

	props: {
		disabled: {
			type: Boolean,
			default: false
		},

		disabledTooltipText: {
			type: String,
			default: ''
		},

		iconLeft: {
			type: String,
			default: ''
		},

		iconRight: {
			type: String,
			default: ''
		},

		level: {
			type: String,
			required: false,
			default: 'primary',
			validator: function (value: string)
			{
				// The value must match one of these strings
				return ['primary', 'secondary', 'tertiary', 'outline', 'outline-primary'].indexOf(value) !== -1;
			}
		},

		size: {
			type: String,
			required: false,
			validator: function (value: string)
			{
				// The value must match one of these strings
				return ['xs', 'sm', 'md', 'lg', 'xl'].indexOf(value) !== -1;
			}
		},

		isFullWidth: {
			type: Boolean,
			default: false
		},

		isFullWidthMobile: {
			type: Boolean,
			default: false
		},
	},

	data: () => ({
		tooltipVisible: false,
		tooltipTop: '0'
	}),

	methods: {
		onMouseEnter ()
		{
			this.$emit('mouseenter');
			if (this.disabled && this.disabledTooltipText != '')
			{
				// This sets the position of the tooltip such that it's 5px above button.
				// I couldn't think of a great way to do this in css since you can only
				// absolutely position elements relative to their top-left corner.
				let tooltip = this.$refs.tooltip;
				if (tooltip && 'clientHeight' in tooltip)
				{
					let height = tooltip.clientHeight;
					const bottomPadding = 5; //px
					this.tooltipVisible = true;
					this.tooltipTop = (-1 * (height + bottomPadding)) + 'px';
				}
			}
		},

		onMouseLeave ()
		{
			this.$emit('mouseleave');
			let tooltip = this.$refs.tooltip;
			if (tooltip)
			{
				this.tooltipVisible = false;
			}
		}
	}

});
